$(document).ready(function () {

  $('.Multiple_question_continue_btn').mouseover(function(){
    $(this).addClass('hovered');
  });

  $('.Multiple_question_continue_btn').mouseleave(function(){
    $(this).removeClass('hovered');
  });

  $('.qz_faq_cell').click(function(){
    $(this).toggleClass('active');
    $(this).find('.qz_faq_info').slideToggle();
  });

   $('.tbss_grid').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow rotatedArrow' src='https://cdn.shopify.com/s/files/1/0626/9576/8321/files/Group_11_1.png?v=1728561651'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0626/9576/8321/files/Group_11_1.png?v=1728561651'/></button>",
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: true
        }
      }
    ]
  });


  $('.tb_reviews_grid.Mobile_only').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          dots: true
        }
      }
    ]
  });

  $('.qzors_carousel').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrow: false
  });


  $('.qz_inputs_mea_sel').click(function(){
    $(this).closest('.Quiz_question_inner ').find('.qz_inputs_mea_sel').removeClass('active');
    $(this).addClass('active');
    var data = $(this).attr('data');
    $(this).closest('.Quiz_question_inner ').find('.qz_input_outer').hide();
    $('.qz_input_outer[data="'+data+'"]').show();

    var x = '';
    var data = $(this).closest('.Quiz_question_inner ').find('.qz_inputs_mea_sel.active').attr('data');
    calculateWeight(x, x, data);
  });

  $(".qz_input__js").bind('keyup mouseup', function () {
      var dataInput = $(this).attr('data');
      var inputValue = parseFloat($(this).val());
      var data = $(this).closest('.Quiz_question_inner ').find('.qz_inputs_mea_sel.active').attr('data');
      calculateWeight(dataInput, inputValue, data);

  });

  $(".qz_input__js").bind('keyup', function (e) {
    var dataInput = $(this).attr('data');
    var inputValue = parseFloat($(this).val());
    
    if (dataInput == 'ft'){
      if (inputValue > 0){ 
         if (!isNaN(e.key) && e.key.length === 1) { // Ensure only number keys are handled
              $(this).val(e.key);
          }
         $('.qz_input__js[data="in"]').focus();
      }
    }
    if (dataInput == 'name'){
      if ($(this).val().length > 0){
        $('.Name_question_next__js').removeClass('disabled');
      }
      else{
        $('.Name_question_next__js').addClass('disabled');
      }
    }

    if (dataInput == 'ig'){
      if ($(this).val().length > 0){
        $('.Ig_question_next__js').removeClass('disabled');
      }
      else{
        $('.Ig_question_next__js').addClass('disabled');
      }
    }

    if (dataInput == 'barrier'){
      if ($(this).val().length > 0){
        $('.Barrier_question_next__js').removeClass('disabled');
      }
      else{
        $('.Barrier_question_next__js').addClass('disabled');
      }
    }

    if (dataInput == 'lifestyle'){
      if ($(this).val().length > 0){
        $('.Lifestyle_question_next__js').removeClass('disabled');
      }
      else{
        $('.Lifestyle_question_next__js').addClass('disabled');
      }
    }

    if (dataInput == 'video'){
      if ($(this).val().length > 0){
        $('.Video_question_next__js').removeClass('disabled');
      }
      else{
        $('.Video_question_next__js').addClass('disabled');
      }
    }
    
  });


  function calculateWeight(dataInput, inputValue, data){
      var value = parseFloat($('.qz_input_outer[data="'+data+'"] input').val());

     console.log(data, value);
      if (data == 'lbs'){
        if (value > 84 && value < 401 ){
          $('.Weight_question_next__js').removeClass('disabled');
        }
        else{
          $('.Weight_question_next__js').addClass('disabled');
        }
      }
      else if (data == 'kg'){
        if (value > 39 && value < 200 ){
          $('.Weight_question_next__js').removeClass('disabled');
        }
        else{
          $('.Weight_question_next__js').addClass('disabled');
        }
      }
      else if (data == 'ft'){
        var valueFt = parseFloat($('.qz_input__js[data="ft"]').val());
        var valueIn = parseFloat($('.qz_input__js[data="in"]').val());
        console.log(valueFt, valueIn,'VALUES')
        if (valueFt > 0 && valueIn > 0){
          $('.Height_question_next__js').removeClass('disabled');
        }
        else{
          $('.Height_question_next__js').addClass('disabled');
        }
      }
      else if (data == 'cm'){
        if (value > 0 && value < 300 ){
          $('.Height_question_next__js').removeClass('disabled');
        }
        else{
          $('.Height_question_next__js').addClass('disabled');
        }
      }

      console.log(dataInput, inputValue);
      if (dataInput == 'years'){
        if (inputValue > 17 && inputValue < 150 ){
          $('.Years_question_next__js').removeClass('disabled');
        }
        else{
          $('.Years_question_next__js').addClass('disabled');
        }
      }
  }

  
  var current_url = window.location.href;
  if (current_url.indexOf('#') != -1) {
    var url_splitted = current_url.split('#');
    window.location.replace(url_splitted[0]);
  }


  

  $('.qr_grid_slider').slick({
    infinite: true,
    arrows: false, 
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '40px',
    autoplay: true,
    autoplaySpeed: 4000
  });
  // Setup the quiz'
  

  $(document).on("click",".Quiz_frontpage_trigger__js",function() {
    $(this).addClass('activated');
    var current_url = window.location.href;
    var url_splitted = current_url.split('#');
    var new_url = url_splitted[0] + '#' + 1;
    // console.log(new_url);
    window.location.replace(new_url);
    $('.Quiz_main_frontpage').hide();
    $('#shopify-section-footer-main').hide();
    $('.Quiz_header').hide();
    $('.Quiz_header_when_in_quiz').show();
    $('.Quiz_question_1__js').css('display', 'flex');
    var question_length = parseFloat($('.Question_amount').attr('data-questions_amount'));
    $('.Quiz_header_question_info_js').text('1/' + question_length);


    var value = $(this).text();
    // console.log(value);

    // Analytics tracking 
    gtag('event', 'click', {
      'event_category': 'Button',
      'event_label': 'Started Quiz'
    });
    console.log('Started quiz event sended to GA');
  });

  // Question next

  $('.La_next_question_trigger__js').click(function(){
    var currentVal = $(this).find('div').html();
    if (String(currentVal).indexOf('Yes') != -1){
       // var answer_index = $(this).attr('data-answer');
        var current_index = parseFloat($(this).attr('data-index'));
        var next_index = current_index + 1;
        var current_question_index = parseFloat($(this).attr('data-question-index'));
        // var group = 1;
    
        // Indexing quiz questions
        
        // Progress bar width selection
        var width;
        var question_length = parseFloat($('.Question_amount').val()) + 1;
        var only_questions = parseFloat($('.Question_amount').attr('data-questions_amount'));
        var multiplier = 100 / only_questions;
        width = (current_question_index) * multiplier;
        console.log(width, current_question_index, multiplier);
    
        // Change color
        $('.Answer_block').removeClass('active');
        $(this).addClass('active');
        setTimeout(function () {
          if (question_length == next_index) {
            $('.Quiz_question').hide();
            $('.Quiz_loading_page').css('display', 'flex');
            $('.Quiz-header_progres_bar__inner').css('width', width + '%');
            $('.Quiz_header_question_info_js').text(next_index + '/' + only_questions);
            $('.Quiz_header_back').css('opacity', '0');
            Start_calculating();
          }
          else {
            $('.Quiz_question').hide();
            $('.Quiz_question_' + next_index + '__js').css('display', 'flex');
            $('.Quiz-header_progres_bar__inner').css('width', width + '%');
            $('.Quiz_header_question_info_js').text(next_index + '/' + only_questions);
            $('.Quiz_header_back').css('opacity', '1');
            $('.Quiz_header_back').attr('data-current', next_index);
          }
          console.log(current_question_index);
    
        }, 200);
    }
    else{
      
      var sex = $('.Quiz_frontpage_trigger__js.activated').attr('data');
      if (sex == 'female'){
        window.location.href = '/pages/quiz-no-la-female';
      }
      else{
        window.location.href = '/pages/quiz-no-la';
      }
      
    }
  });

  $('.Height_question_next__js').click(function () {
    if ($(this).hasClass('disabled')){
      
    }
    else{
          
        // var answer_index = $(this).attr('data-answer');
        var current_index = parseFloat($(this).attr('data-index'));
        var next_index = current_index + 1;
        var current_question_index = parseFloat($(this).attr('data-question-index'));
        // var group = 1;
    
        // Indexing quiz questions
        
        // Progress bar width selection
        var width;
        var question_length = parseFloat($('.Question_amount').val()) + 1;
        var only_questions = parseFloat($('.Question_amount').attr('data-questions_amount'));
        var multiplier = 100 / only_questions;
        width = (current_question_index) * multiplier;
        console.log(width, current_question_index, multiplier);
    
        // Change color
        $('.Answer_block').removeClass('active');
        $(this).addClass('active');
        setTimeout(function () {
          if (question_length == next_index) {
            $('.Quiz_question').hide();
            $('.Quiz_loading_page').css('display', 'flex');
            $('.Quiz-header_progres_bar__inner').css('width', width + '%');
            $('.Quiz_header_question_info_js').text(next_index + '/' + only_questions);
            $('.Quiz_header_back').css('opacity', '0');
            Start_calculating();
          }
          else {
            $('.Quiz_question').hide();
            $('.Quiz_question_' + next_index + '__js').css('display', 'flex');
            $('.Quiz-header_progres_bar__inner').css('width', width + '%');
            $('.Quiz_header_question_info_js').text(next_index + '/' + only_questions);
            $('.Quiz_header_back').css('opacity', '1');
            $('.Quiz_header_back').attr('data-current', next_index);
          }
          console.log(current_question_index);
    
        }, 200);
    
        
    }
  });

  $('.Years_question_next__js').click(function () {
    if ($(this).hasClass('disabled')){
      
    }
    else{
          
        // var answer_index = $(this).attr('data-answer');
        var current_index = parseFloat($(this).attr('data-index'));
        var next_index = current_index + 1;
        var current_question_index = parseFloat($(this).attr('data-question-index'));
        // var group = 1;
    
        // Indexing quiz questions
        
        // Progress bar width selection
        var width;
        var question_length = parseFloat($('.Question_amount').val()) + 1;
        var only_questions = parseFloat($('.Question_amount').attr('data-questions_amount'));
        var multiplier = 100 / only_questions;
        width = (current_question_index) * multiplier;
        console.log(width, current_question_index, multiplier);
    
        // Change color
        $('.Answer_block').removeClass('active');
        $(this).addClass('active');
        setTimeout(function () {
          if (question_length == next_index) {
            $('.Quiz_question').hide();
            $('.Quiz_loading_page').css('display', 'flex');
            $('.Quiz-header_progres_bar__inner').css('width', width + '%');
            $('.Quiz_header_question_info_js').text(next_index + '/' + only_questions);
            $('.Quiz_header_back').css('opacity', '0');
            Start_calculating();
          }
          else {
            $('.Quiz_question').hide();
            $('.Quiz_question_' + next_index + '__js').css('display', 'flex');
            $('.Quiz-header_progres_bar__inner').css('width', width + '%');
            $('.Quiz_header_question_info_js').text(next_index + '/' + only_questions);
            $('.Quiz_header_back').css('opacity', '1');
            $('.Quiz_header_back').attr('data-current', next_index);
          }
          console.log(current_question_index);
    
        }, 200);
    
        
    }
  });

  $('.Weight_question_next__js').click(function () {
    if ($(this).hasClass('disabled')){
      
    }
    else{
          
        // var answer_index = $(this).attr('data-answer');
        var current_index = parseFloat($(this).attr('data-index'));
        var next_index = current_index + 1;
        var current_question_index = parseFloat($(this).attr('data-question-index'));
        // var group = 1;
    
        // Indexing quiz questions
        
        // Progress bar width selection
        var width;
        var question_length = parseFloat($('.Question_amount').val()) + 1;
        var only_questions = parseFloat($('.Question_amount').attr('data-questions_amount'));
        var multiplier = 100 / only_questions;
        width = (current_question_index) * multiplier;
        console.log(width, current_question_index, multiplier);
    
        // Change color
        $('.Answer_block').removeClass('active');
        $(this).addClass('active');
        setTimeout(function () {
          if (question_length == next_index) {
            $('.Quiz_question').hide();
            $('.Quiz_loading_page').css('display', 'flex');
            $('.Quiz-header_progres_bar__inner').css('width', width + '%');
            $('.Quiz_header_question_info_js').text(next_index + '/' + only_questions);
            $('.Quiz_header_back').css('opacity', '0');
            Start_calculating();
          }
          else {
            $('.Quiz_question').hide();
            $('.Quiz_question_' + next_index + '__js').css('display', 'flex');
            $('.Quiz-header_progres_bar__inner').css('width', width + '%');
            $('.Quiz_header_question_info_js').text(next_index + '/' + only_questions);
            $('.Quiz_header_back').css('opacity', '1');
            $('.Quiz_header_back').attr('data-current', next_index);
          }
          console.log(current_question_index);
    
        }, 200);
    
        
    }
  });


  $('.TextField_question_next__js_front').click(function () {
    if ($(this).hasClass('disabled')){
      
    }
    else{
          
        // var answer_index = $(this).attr('data-answer');
        var current_index = parseFloat($(this).attr('data-index'));
        var next_index = current_index + 1;
        var current_question_index = parseFloat($(this).attr('data-question-index'));
        // var group = 1;
    
        // Indexing quiz questions
        
        // Progress bar width selection
        var width;
        var question_length = parseFloat($('.Question_amount').val()) + 1;
        var only_questions = parseFloat($('.Question_amount').attr('data-questions_amount'));
        var multiplier = 100 / only_questions;
        width = (current_question_index) * multiplier;
        console.log(width, current_question_index, multiplier);
    
        // Change color
        $('.Answer_block').removeClass('active');
        $(this).addClass('active');
        setTimeout(function () {
          if (question_length == next_index) {
            $('.Quiz_question').hide();
            $('.Quiz_loading_page').css('display', 'flex');
            $('.Quiz-header_progres_bar__inner').css('width', width + '%');
            $('.Quiz_header_question_info_js').text(next_index + '/' + only_questions);
            $('.Quiz_header_back').css('opacity', '0');
            Start_calculating();
          }
          else {
            $('.Quiz_question').hide();
            $('.Quiz_question_' + next_index + '__js').css('display', 'flex');
            $('.Quiz-header_progres_bar__inner').css('width', width + '%');
            $('.Quiz_header_question_info_js').text(next_index + '/' + only_questions);
            $('.Quiz_header_back').css('opacity', '1');
            $('.Quiz_header_back').attr('data-current', next_index);
          }

          $('.Quiz_header_when_in_quiz').show();
          $('.Quiz_question_1__js').css('display', 'flex');
          var question_length = parseFloat($('.Question_amount').attr('data-questions_amount'));
          $('.Quiz_header_question_info_js').text('1/' + question_length);
          console.log(current_question_index);
    
        }, 200);
    
        
    }
  });



  $('.TextField_question_next__js').click(function () {
    if ($(this).hasClass('disabled')){
      
    }
    else{
          
        // var answer_index = $(this).attr('data-answer');
        var current_index = parseFloat($(this).attr('data-index'));
        var next_index = current_index + 1;
        var current_question_index = parseFloat($(this).attr('data-question-index'));
        // var group = 1;
    
        // Indexing quiz questions
        
        // Progress bar width selection
        var width;
        var question_length = parseFloat($('.Question_amount').val()) + 1;
        var only_questions = parseFloat($('.Question_amount').attr('data-questions_amount'));
        var multiplier = 100 / only_questions;
        width = (current_question_index) * multiplier;
        console.log(width, current_question_index, multiplier);
    
        // Change color
        $('.Answer_block').removeClass('active');
        $(this).addClass('active');
        setTimeout(function () {
          if (question_length == next_index) {
            $('.Quiz_question').hide();
            $('.Quiz_loading_page').css('display', 'flex');
            $('.Quiz-header_progres_bar__inner').css('width', width + '%');
            $('.Quiz_header_question_info_js').text(next_index + '/' + only_questions);
            $('.Quiz_header_back').css('opacity', '0');
            Start_calculating();
          }
          else {
            $('.Quiz_question').hide();
            $('.Quiz_question_' + next_index + '__js').css('display', 'flex');
            $('.Quiz-header_progres_bar__inner').css('width', width + '%');
            $('.Quiz_header_question_info_js').text(next_index + '/' + only_questions);
            $('.Quiz_header_back').css('opacity', '1');
            $('.Quiz_header_back').attr('data-current', next_index);
          }
          console.log(current_question_index);
    
        }, 200);
    
        
    }
  });

  $('.Next_question_trigger__js').click(function () {

   

    
    
    // var answer_index = $(this).attr('data-answer');
    var current_index = parseFloat($(this).attr('data-index'));
    var next_index = current_index + 1;
    var current_question_index = parseFloat($(this).attr('data-question-index'));
    // var group = 1;

    // Indexing quiz questions
    var current_url = window.location.href;
    if (current_url.indexOf('#') != -1) {
      var url_splitted = current_url.split('#');
      var next_url_index = next_index;
      var new_url = url_splitted[0] + '#' + next_url_index;
      // console.log(new_url);
      window.location.replace(new_url);
    }

    // Progress bar width selection
    var width;
    var question_length = parseFloat($('.Question_amount').val()) + 1;
    var only_questions = parseFloat($('.Question_amount').attr('data-questions_amount'));
    var multiplier = 100 / only_questions;
    width = (current_question_index) * multiplier;
    console.log(width, current_question_index, multiplier);

    // Change color
    $('.Answer_block').removeClass('active');
    $(this).addClass('active');
    setTimeout(function () {
      if (question_length == next_index) {
        $('.Quiz_question').hide();
        $('.Quiz_loading_page').css('display', 'flex');
        $('.Quiz-header_progres_bar__inner').css('width', width + '%');
        $('.Quiz_header_question_info_js').text(next_index + '/' + only_questions);
        $('.Quiz_header_back').css('opacity', '0');
        Start_calculating();
      }
      else {
        $('.Quiz_question').hide();
        $('.Quiz_question_' + next_index + '__js').css('display', 'flex');
        $('.Quiz-header_progres_bar__inner').css('width', width + '%');
        $('.Quiz_header_question_info_js').text(next_index + '/' + only_questions);
        $('.Quiz_header_back').css('opacity', '1');
        $('.Quiz_header_back').attr('data-current', next_index);
      }
      console.log(current_question_index);

    }, 200);

    // Analytics tracking 
    gtag('event', 'click', {
      'event_category': 'Button',
      'event_label': 'Passed Question ' + current_index
    });

      if ($(this).attr('data-age') == 'true'){
         console.log($(this).find('div').text(), 'cookie set');
        document.cookie = "age_v="+$(this).find('div').text()+"; path=/";
      }

    console.log('Passed Question Nr. ' + current_index + ' event sended to GA');

    var dataGain = $(this).attr('data-gain-bol');
    if (dataGain == 'true'){
      var value = $(this).attr('data-gain');
      $('.Quiz_header_when_in_quiz').attr('data-gain', value);
    }

  });

  $('.Multiple_question_trigger__js').click(function () {
    $(this).toggleClass('active');
    var selected_selector = 0;
    $('.Multiple_question_trigger__js').each(function () {
      if ($(this).hasClass('active')) selected_selector++;
    });
    console.log(selected_selector);
    if (selected_selector != 0) {
      $('.Multiple_question_next__js').removeClass('disabled');
    } else {
      $('.Multiple_question_next__js').addClass('disabled');
    }
  });

  $('.Multiple_question_next__js').click(function () {
    if (!$(this).hasClass('disabled')) {
      var current_index = parseFloat($(this).attr('data-index'));
      var next_index = current_index + 1;
      var current_question_index = parseFloat($(this).attr('data-question-index'));

      // Indexing quiz questions
      var current_url = window.location.href;
      if (current_url.indexOf('#') != -1) {
        var url_splitted = current_url.split('#');
        var next_url_index = next_index;
        var new_url = url_splitted[0] + '#' + next_url_index;
        // console.log(new_url);
        window.location.replace(new_url);
      }

      // console.log(next_index);
      $('.Quiz_question').hide();
      $('.Quiz_question_' + next_index + '__js').css('display', 'flex');
      $('.Multiple_question_next__js').addClass('disabled');
      $('.Multiple_question_trigger__js').removeClass('active');
      // Progress bar width selection
      var width;
      var question_length = parseFloat($('.Question_amount').val()) + 1;
      var only_questions = parseFloat($('.Question_amount').attr('data-questions_amount'));
      var multiplier = 100 / only_questions;

      width = (current_question_index) * multiplier;
      console.log(width, current_question_index, multiplier);
      if (question_length == next_index) {
        $('.Quiz_question').hide();
        $('.Quiz_loading_page').css('display', 'flex');
        $('.Quiz-header_progres_bar__inner').css('width', width + '%');
        $('.Quiz_header_question_info_js').text(next_index + '/' + only_questions);
        $('.Quiz_header_back').css('opacity', '0');
        Start_calculating();
      }
      else {
        $('.Quiz-header_progres_bar__inner').css('width', width + '%');
        $('.Quiz_header_question_info_js').text(next_index + '/' + only_questions);
        $('.Quiz_header_back').css('opacity', '1');
        $('.Quiz_header_back').attr('data-current', next_index);
      }
    }
    // Analytics tracking 
    gtag('event', 'click', {
      'event_category': 'Button',
      'event_label': 'Passed Question ' + current_index.toString()
    });
    console.log('Passed Question Nr. ' + current_index + ' event sended to GA');
  });

  $('.Text_question_next__js').click(function () {
    var current_index = parseFloat($(this).attr('data-index'));
    var next_index = current_index + 1;
    var next_question_index = parseFloat($('.Quiz_question_' + current_index + '__js').attr('data-question-index'));
    console.log(current_index, next_index, next_question_index)
    // Indexing quiz questions
    var current_url = window.location.href;
    if (current_url.indexOf('#') != -1) {
      var url_splitted = current_url.split('#');
      var next_url_index = next_index;
      var new_url = url_splitted[0] + '#' + next_url_index;
      // console.log(new_url);
      window.location.replace(new_url);
    }
    // console.log(next_index);
    $('.Quiz_question').hide();
    $('.Quiz_question_' + next_index + '__js').css('display', 'flex');
    // Progress bar width selection
    var width;
    var question_length = parseFloat($('.Question_amount').val()) + 1;
    var only_questions = parseFloat($('.Question_amount').attr('data-questions_amount'));
    var multiplier = 100 / only_questions;

    width = next_question_index * multiplier;

    if (question_length == next_index) {
      $('.Quiz_question').hide();
      $('.Quiz_loading_page').css('display', 'flex');
      $('.Quiz-header_progres_bar__inner').css('width', width + '%');
      $('.Quiz_header_question_info_js').text(next_question_index + '/' + only_questions);
      $('.Quiz_header_back').css('opacity', '0');
      Start_calculating();
    }
    else {
      $('.Quiz-header_progres_bar__inner').css('width', width + '%');
      $('.Quiz_header_question_info_js').text(next_question_index + '/' + only_questions);
      $('.Quiz_header_back').css('opacity', '1');
      $('.Quiz_header_back').attr('data-current', next_index);
    }
    // Analytics tracking 
    gtag('event', 'click', {
      'event_category': 'Button',
      'event_label': 'Passed Question ' + current_index.toString()
    });
    console.log('Passed Question Nr. ' + current_index + ' event sended to GA');
  });


  // $('.Science_cell_header__js').click(function () {
  //   $(this).toggleClass('active');
  //   $(this).find('.Offer_science_cell_text').slideToggle();
  // });

  // $('.Offer_faq_tab').click(function () {
  //   $(this).toggleClass('active');
  //   $(this).find('.Offer_faq_answer').slideToggle();
  // });

  // $('.Header_scroll_js').click(function () {
  //   var window_url = String(window.location);
  //   if (window_url.indexOf('main-3') != -1 || window_url.indexOf('sale-offer') != -1) {
  //     ga('send', 'event', 'Button', 'Click', 'Clicked Claim My plan from:  ' + window_url + '');
  //     console.log('Clicked Claim My plan from:  ' + window_url + ' Event Sended');
  //   }
  //   $('html, body').animate({
  //     scrollTop: $(".Offer__section__js").offset().top - 100
  //   }, 500);
  // });

  // // 15minutes timer

  // function shortTimer() {
  //   function timerCountDown() {
  //     var timeLeft = parseFloat($('.Offer_get_your_plan_timer_seconds').attr('data'));
  //     timeLeft--;
  //     $('.Offer_get_your_plan_timer_seconds').attr('data', timeLeft);
  //     var minutes = timeLeft / 60;
  //     minutes = Math.floor(minutes);
  //     var seconds = timeLeft - (minutes * 60);
  //     // console.log(minutes, seconds, 'timer');
  //     $('.Offer_get_your_plan_timer_minutes').text(minutes);
  //     $('.Offer_get_your_plan_timer_seconds').text(seconds);
  //   }

  //   setInterval(timerCountDown, 1000);
  // }

  // // Random numbers generator 

  // function getRandomArbitrary(min, max) {
  //   return Math.round(Math.random() * (max - min) + min);
  // }
  // var similar_result = getRandomArbitrary(75, 87);
  // var statistic_data_1 = getRandomArbitrary(76, 86);
  // var statistic_data_2 = getRandomArbitrary(65, 76);
  // var statistic_data_3 = getRandomArbitrary(41, 58);
  // var your_score = getRandomArbitrary(25, 34);

  // // $('.Offer_procrastination_similar_score').text(similar_result+'%');
  // $('.summary_number_1__js').text(statistic_data_1 + '%');
  // $('.summary_number_2__js').text(statistic_data_2 + '%');
  // $('.summary_number_3__js').text(statistic_data_3 + '%');

  $('.qr_grid').slick({
    infinite: true,
    arrows: false, 
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '30px'
        }
      }
    ]
  });

  // Set the initial countdown time (15 minutes = 900 seconds)
    var countdownTime = 15 * 60;

    // Function to update the timer display
    function updateTimer() {
        // Calculate minutes and seconds
        var minutes = Math.floor(countdownTime / 60);
        var seconds = countdownTime % 60;

        // Update the HTML content
        $('.qzo_m').text(('0' + minutes).slice(-2)); // Add leading zero if needed
        $('.qzo_s').text(('0' + seconds).slice(-2));

        // Decrement the time
        countdownTime--;

        // If time reaches zero, stop the timer
        if (countdownTime < 0) {
            clearInterval(timerInterval);
            $('.qzo_h').text('00');
            $('.qzo_m').text('00');
            $('.qzo_s').text('00');
        }
    }

    // Update the timer every second
    var timerInterval = setInterval(updateTimer, 1000);

    // Start the timer immediately
    updateTimer();

});


// Calculating Percentage
var redirectFlag = false; 

function Start_calculating() {
  setInterval(Calculating, 100);
}

function Calculating() {
  var data = parseFloat($('.Quiz_calculating_percent__js').attr('data'));
  const ranges = [
    { range: [0, 20], value: 1 },
    { range: [20, 22], value: 0.15 },
    { range: [22, 29], value: 1.3 },
    { range: [29, 32], value: 3 },
    { range: [32, 45], value: 4 },
    { range: [45, 48], value: 0.7 },
    { range: [48, 57], value: 1.4 },
    { range: [57, 87], value: 4 },
    { range: [87, 93], value: 2.3 },
    { range: [93, 97], value: 4 },
    { range: [97, 100], value: 0.4 }
  ];
  for (const range of ranges) {
    if (data >= range.range[0] && data < range.range[1]) {
      data += range.value;
      break;
    }
  }

  if (data >= 100 && !redirectFlag) {
    var next_url = $('.Quiz_calculating_percent__js').attr('next_url');
    // window.location.replace(next_url);
    getValues();
    redirectFlag = true; // Set the flag to true to prevent further redirections
    return; // Exit the function early
  }

  data_rounded = Math.round(data);
  $('.Quiz_calculating_percent__js').attr('data', data);
  $('.Quiz_calculating_percent__js').text(data_rounded + '%');
}


// EMAIL FIELD

function runEmailChecker() {
  function checkEmail() {
    var checkingItemAttr = $('.kl-private-reset-css-Xuajs1').find('p').find('span').text();
    console.log(checkingItemAttr);
    if (checkingItemAttr.indexOf('Check your email for a confirmation message.') != -1) {

      var next_url = $('.Quiz_calculating_percent__js').attr('next_url');
      // window.location.replace(next_url);
      getValues();
      $('.kl-private-reset-css-Xuajs1').find('p').find('span').text('Your Results');
      // Start_calculating();
      
    }
  }
  setInterval(checkEmail, 500);
}

runEmailChecker();


function getValues(){
  var currentUrl = String(window.location.href);
  var sex = $('.Quiz_frontpage_trigger__js.activated').attr('data');
  var forApp = '';
  if (currentUrl.indexOf('no-la-female') != -1){
    sex = 'female';
  }
  else if (currentUrl.indexOf('no-la') != -1){
    sex = 'male';
  }
  
  var years = $('.qz_input__js[data="years"]').val();
  var weightKg = $('.qz_input__js[data="kg"]').val();
  var weightLbs = $('.qz_input__js[data="lbs"]').val();
  var heightCm = $('.qz_input__js[data="cm"]').val();
  var heightFt = $('.qz_input__js[data="ft"]').val();
  var heightIn = $('.qz_input__js[data="in"]').val();

  var goal = $('.Quiz_header_when_in_quiz').attr('data-gain');

  var weigthMea = $('.qz_inputs_mea_selector[data="weight"]').find('.qz_inputs_mea_sel.active').attr('data');
  var heigthMea = $('.qz_inputs_mea_selector[data="height"]').find('.qz_inputs_mea_sel.active').attr('data');

  var parameters = '?'+sex+'/'+years+'/'+weightKg+'/'+weightLbs+'/'+heightCm+'/'+heightFt+'/'+heightIn+'/'+weigthMea+'/'+heigthMea + '/'+ goal;

  
  if (currentUrl.indexOf('to-offer') != -1 ){
    var newUrl = '/pages/quiz-offer-for-app' + parameters;
  }
  else if (currentUrl.indexOf('no-la') != -1){
    var newUrl = '/pages/quiz-offer-for-app-no-la' + parameters;
  }
  else{
    var newUrl = '/pages/quiz-results-la-based' + parameters;
  }
  
  window.location.href = newUrl;
}


// Carousels
